import React, { useState, useEffect } from 'react';
import { Button } from 'react-bootstrap';
import { showToast } from '../ShowToast/ToastNotification';
import { api_url } from '../../constant/constant';
import { t } from 'i18next';

function SSOConfig() {
  const [provider, setprovider] = useState(''); // provider
  const [client_secret, setclient_secret] = useState(''); // client_secret
  const [client_id, setclient_id] = useState(''); // client_id
  const [redirect_uri, setredirect_uri] = useState(''); // redirect_uri
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  useEffect(() => {
    fetchSSOConfigData();
  }, []);

  const fetchSSOConfigData = async () => {
    try {
      const token = localStorage.getItem('userToken');
      const response = await fetch(`${api_url}/oauth-config`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
      const result = await response.json();

      if (result?.data) {
        const config = result.data;
        setprovider(config.provider || '');
        setclient_secret(config.client_secret || '');
        setclient_id(config.client_id || '');
        setredirect_uri(config.redirect_uri || '');
      }
    } catch (error) {
      console.error('Failed to fetch OAuth config:', error);
      showToast(t('errorFetchingSSOConfigData'), 'error');
    }
  };

  const handleSaveSSOConfig = async (e) => {
    e.preventDefault();

    if (!provider || !client_secret || !client_id || !redirect_uri) {
      showToast('Please fill in all fields.', 'error');
      return;
    }

    setLoading(true);
    try {
      const token = localStorage.getItem('userToken');
      const payload = {
        provider: provider,
        client_secret: client_secret,
        client_id: client_id,
        redirect_uri: redirect_uri,
      };

      const response = await fetch(`${api_url}/oauth-config`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
      });

      const data = await response.json();

      if (response.ok && data?.status === 'success') {
        showToast(t('SSOConfigSaved'), 'success');
      } else {
        showToast(data?.message || t('errorSavingSSOConfig'), 'error');
      }
    } catch (err) {
      console.error('Error saving OAuth settings:', err);
      showToast(t('errSavingSSOConfig'), 'error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className='container-fluid'
      style={{ border: '1px solid #EAEAEA', borderRadius: '10px', padding: '15px' }}
    >
      <form onSubmit={handleSaveSSOConfig}>
        <div className='row g-3 mt-3'>
          <div className='col-12 col-md-6'>
            <label className='form-label'>{t('Provider')}</label>
            <input
              type='text'
              className='form-control'
              value={provider}
              onChange={(e) => setprovider(e.target.value)}
              required
            />
          </div>
          <div className='col-12 col-md-6 position-relative'>
            <label className='form-label'>{t('ClientSecret')}</label>
            <input
              type={showPassword ? 'text' : 'password'}
              className='form-control pe-5' 
              value={client_secret}
              onChange={(e) => setclient_secret(e.target.value)}
              required
            />
            <i
              className={`bi ${showPassword ? 'bi-eye-slash' : 'bi-eye'} position-absolute`}
              onClick={() => setShowPassword(!showPassword)}
              style={{
                top: '73%',
                right: '15px',
                transform: 'translateY(-50%)',
                cursor: 'pointer',
                fontSize: '1.2rem',
                color: '#6c757d',
              }}
            ></i>
          </div>
        </div>

        <div className='row g-3 mt-3'>
          <div className='col-12 col-md-6'>
            <label className='form-label'>{t('RedirectURI')}</label>
            <input
              type='text'
              className='form-control'
              value={redirect_uri}
              onChange={(e) => setredirect_uri(e.target.value)}
              pattern='https?://.+\.(com|net|org|pk|in|edu)(/.*)?'
              title='Please enter a valid URL with .com, .net, .org, etc.'
              required
            />
          </div>
          <div className='col-12 col-md-6'>
            <label className='form-label'>{t('ClientID')}</label>
            <input
              type='text'
              className='form-control'
              value={client_id}
              onChange={(e) => setclient_id(e.target.value)}
              required
            />
          </div>
        </div>

        <div className='d-flex justify-content-end mt-4'>
          <Button variant='primary' type='submit' disabled={loading}>
            {loading ? t('Saving...') : t('Save')}
          </Button>
        </div>
      </form>
    </div>
  );
}

export default SSOConfig;
